var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quantity-counter-wrapper"},[_c('i',{staticClass:"fa-solid fa-minus quantity-decrement jump",on:{"click":_vm.decrementHandler}}),_c('p',{staticClass:"quantity-count"},[_vm._v(_vm._s(_vm.quantity))]),_c('i',{staticClass:"fa-solid fa-plus quantity-increment jump",on:{"click":_vm.incrementHandler}})])
}
var staticRenderFns = []

export { render, staticRenderFns }